export default __webpack_public_path__ + "static/media/k8s.e4489cb0.png";